export default (state = [], action) => {

    switch (action.type) {
        case 'LOAD_INSTALLERS':
            return action.payload.result;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/installers_reducer.js